import React from 'react';
import FormModal from '../../../../common/components/FormModal';

const ApproachesResetModal = ({
  visible,
  onSubmit,
  onCancel,
  type,
}) => (
    <FormModal
      title="Confirm Reset"
      onSubmit={onSubmit}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose={true}
      okText="Confirm"
      cancelText="Cancel"
      initialValues={{}}
    >
      {() => (
        <p>
          Are you sure you want to reset to default values?
        </p>
      )}
    </FormModal>
  );

export default ApproachesResetModal;
